import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { UtcMomentDateAdapterService } from './services/utc-moment-date-adapter.service';
import { ReactiveFormsModule } from '@angular/forms';
import { StpMaterialModule } from '../material/material.module';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { StpFormsModule } from '../../stp-app/forms/forms.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    StpMaterialModule,
    StpFormsModule
  ],
  exports: [
    DatePickerComponent
  ],
  declarations: [
    DatePickerComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-NZ' },
    {
      provide: DateAdapter,
      useClass: UtcMomentDateAdapterService,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class StpDatePickerModule { }
